import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import "../../Pages/PageHomeOut/PageHomeOut.css";
import punto1 from "../../../Resources/Images/HomeOut/BB_multicolor_cohete.webp";
import punto2 from "../../../Resources/Images/HomeOut/BB_multicolor_valor.webp";
import punto3 from "../../../Resources/Images/HomeOut/BB_multicolor_seguridad.webp";
import punto4 from "../../../Resources/Images/HomeOut/BB_multicolor_corazon.webp";
import imgPuntos from "../../../Resources/Images/HomeOut/img_puntos.webp";
import ImgPuntosMobile from "../../../Resources/Images/HomeOut/img-puntos-mobile.webp";


const PageHomeOutAsegurado = () => {
  return (
    <>
      <div className="d-block d-md-none">
        <Row className="w-100 justify-content-center align-items-center mt-5">
          <Col className="col-12 py-4">
            <p className="subtitulo__importancia text-center font20px mb-4">
              La importancia de estar asegurado
            </p>
            <Row className="w-100 p-0 m-0 justify-content-center">
              <Col className="col-9">
                <Image
                  alt="imagen puntos"
                  className="image__puntos d-block mx-auto"
                  src={ImgPuntosMobile}
                />
              </Col>
            </Row>
            <Row className="align-items-center mt-5">
              <Col className="col-3 col-md-1 col-lg-auto text-center">
                <img
                  width={68}
                  height={68}
                  alt="punto 1"
                  src={punto1}
                  style={{ padding: "10px" }}
                ></img>
              </Col>
              <Col className="col-9 col-lg-10 pt-3 px-0 fontOpenSans">
                <p> 
                  <strong>
                    Puedes tener acceso a los beneficios al momento de
                    activar al seguro.
                  </strong>
                </p>
              </Col>
            </Row>
            <Row className="align-items-center mt-3">
              <Col className="col-3 col-md-1 col-lg-auto text-center">
                <img
                  width={68}
                  height={68}
                  alt="punto 2"
                  src={punto2}
                  style={{ padding: "10px" }}
                ></img>
              </Col>
              <Col className="col-9 col-lg-10 pt-3 px-0 fontOpenSans">
                <p> <strong>Beneficios exclusivos.</strong></p>
              </Col>
            </Row>
            <Row className="align-items-center mt-3">
              <Col className="col-3 col-md-1 col-lg-auto text-center">
                <img
                  width={68}
                  height={68}
                  alt="punto 3"
                  src={punto4}
                  style={{ padding: "10px" }}
                ></img>
              </Col>
              <Col className="col-9 col-lg-10 pt-3 px-0 fontOpenSans">
                <p> <strong>Protección para el futuro.</strong></p>
              </Col>
            </Row>
            <Row className="align-items-center mt-3">
              <Col className="col-3 col-md-1 col-lg-auto text-center">
                <img
                  width={68}
                  height={68}
                  alt="punto 4"
                  src={punto3}
                  style={{ padding: "10px" }}
                ></img>
              </Col>
              <Col className="col-9 col-lg-10 pt-3 px-0 fontOpenSans">
                <p> <strong>Pensar en tus seres queridos.</strong></p>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Row 
        className="w-100 d-none d-md-flex py-5 justify-content-center align-items-center container__max__width"
        style={{marginTop:"20px"}}
      >
        <Col className="col-md-12 col-lg-6 px-4 py-4">
          <img
            width={658}
            height={529}
            alt="imagen puntos"
            className="w-100 image__puntos"
            src={imgPuntos}
          ></img>
        </Col>
        <Col className="col-md-12 col-lg-6 pt-4 my-4">
          <p className="subtitulo__importancia font30px ">
            La importancia de {' '}
            <br className="d-md-none d-lg-block"/>
            estar asegurado
          </p>
          <Row className="w-100 p-0 m-0 justify-content-center">
            <Col className="col-md-10 col-lg-12">
              <Row className="w-100 p-0 m-0 align-items-center mb-4">
                <Col className="col-md-2 col-lg-1 p-0">
                  <img
                    width={59}
                    height={59}
                    alt="punto 1"
                    src={punto1}
                    style={{ padding: "5px" }}
                  ></img>
                </Col>
                <Col className="col-10 fontOpenSans font20px mt-4">
                  <span className="align-middle">
                    <strong>
                      Puedes tener acceso a los beneficios 
                      <br/>
                      al momento de
                      activar al seguro.
                    </strong>
                  </span>
                </Col>
              </Row>
              <Row className="w-100 p-0 m-0 align-items-center mb-4">
                <Col className="col-md-2 col-lg-1 p-0">
                  <img
                    width={59}
                    height={59}
                    alt="punto 2"
                    src={punto2}
                    style={{ padding: "5px" }}
                  ></img>
                </Col>
                <Col className="col-10 fontOpenSans font20px">
                  <span className="align-middle">
                    <strong>
                      Beneficios exclusivos.

                    </strong>
                  </span>
                </Col>
              </Row>
              <Row className="w-100 p-0 m-0 align-items-center mb-4">
                <Col className="col-md-2 col-lg-1 p-0">
                  <img
                    width={59}
                    height={59}
                    alt="punto 3"
                    src={punto3}
                    style={{ padding: "5px" }}
                  ></img>
                </Col>
                <Col className="col-10 fontOpenSans font20px">
                  <span className="align-middle">
                    <strong>
                      Protección para el futuro.
                    </strong>
                  </span>
                </Col>
              </Row>
              <Row className="w-100 p-0 m-0 align-items-center mb-4">
                <Col className="col-md-2 col-lg-1 p-0">
                  <img
                    width={59}
                    height={59}
                    alt="punto 4"
                    src={punto4}
                    style={{ padding: "5px" }}
                  ></img>
                </Col>
                <Col className="col-10 fontOpenSans font20px">
                  <span className="align-middle">
                    <strong>
                      Pensar en tus seres queridos.
                    </strong>
                  </span>
                </Col>
              </Row>          
            </Col>
          </Row>
        </Col>
      </Row>      
    </>
  );
};

export default PageHomeOutAsegurado;
